import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    streamName: '',
    loading: false,
}

const NewStream = ({classInfo}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getClasses} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);


    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.streamName.length === 0){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.createStream(classInfo.class_id, state.streamName);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'streamName', value: ''});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getClasses(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


     

  

    return (
        <div className="card-body">

            <CallOut 
                title={`New ${classInfo.class_name} Stream`}
                description={`E.g. ${classInfo.class_name}A, ${classInfo.class_name} East, etc.`}
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Stream Name"
                            placeholder="Stream Name"
                            leftIcon="fa fa-school"
                            value={state.streamName}
                            onChange={e => dispatch({type: 'streamName', value: e.target.value})}
                            required
                            wrap
                            />
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Stream</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewStream;